import { render, staticRenderFns } from "./JoinTab.vue?vue&type=template&id=4c0d53b1&scoped=true"
import script from "./JoinTab.vue?vue&type=script&lang=js"
export * from "./JoinTab.vue?vue&type=script&lang=js"
import style0 from "./JoinTab.vue?vue&type=style&index=0&id=4c0d53b1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0d53b1",
  null
  
)

export default component.exports